module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"cancel":"取消","create":"注册我的信息","update":"修改我的信息","edit":"修改","apply":"应用","reset":"取消选择"}}')
  delete Component.options._Ctor
}
